// extracted by mini-css-extract-plugin
export var copyableField = "_hs-4";
export var customerBadge = "_hs-0";
export var customerInfoTitle = "_hs-2";
export var details = "_hs-1";
export var dropdownContainer = "_hs-5";
export var dropdownImage = "_hs-6";
export var editAssigneeForm = "_hs-a";
export var editButton = "_hs-3";
export var email = "_hs-7";
export var hidden = "_hs-d";
export var input = "_hs-8";
export var saveButton = "_hs-b";
export var shopifyIcon = "_hs-c";
export var suggestionBadge = "_hs-e";
export var suggestionText = "_hs-f";
export var username = "_hs-9";